export const blockIconsActivitiesSportsTennisNew = (
	<span className='material-symbols-outlined'>sports_tennis</span>
);
